import API from "shared/services/Api";
import { IFilters, IFindDoctorResponse } from "shared/types";

export const getAll = async (
  filters: IFilters,
): Promise<IFindDoctorResponse> => {
  const params = new URLSearchParams();

  // obrigatórios
  params.append("page", String(filters.page));

  // opcionais
  if (filters.quantity) params.append("quantity", String(filters.quantity));
  if (filters.provider) params.append("provider", filters.provider);
  if (filters.address) params.append("address", filters.address);
  if (filters.category) params.append("category", filters.category);
  if (filters.typeProvider) params.append("typeProvider", filters.typeProvider);
  if (filters.specialist) params.append("specialist", filters.specialist);
  if (filters.insurance) params.append("insurance", String(filters.insurance));

  if (filters.emergency !== undefined) {
    params.append("emergency", filters.emergency ? "1" : "0");
  }

  if (filters.state) params.append("state", filters.state);
  if (filters.city) params.append("city", filters.city);
  if (filters.region) params.append("region", filters.region);
  if (filters.neighbordhood)
    params.append("neighborhood", filters.neighbordhood);

  if (filters.lat) params.append("latitude", String(filters.lat));
  if (filters.long) params.append("longitude", String(filters.long));

  params.append("networkFilter", filters.networkFilter || "null");
  params.append("sortAlpha", filters?.sortAlpha || "az");

  const url = `services?${params.toString()}`;

  return API.get(url);
};
